module.exports = __webpack_public_path__ + "img/Iion_beauty&wellbeing.fe89e1b3.png";